/* Apps.js */
/* @author: anghello */

import React from 'react';
import { Row, Col, Container } from 'reactstrap';
import Strings from '../../translations/Translations';
import Footer1 from '../../components/commom/Footer1';
import AppBar2 from '../../components/commom/AppBar2/AppBar2';
import RemixApps from '../../components/remix/RemixApps';

export default function About() {
  return (
    <>
      <AppBar2 />

      <div className='min-height-100vh'>
        <Container fluid className='py-4'>
          <Row>
            <Col md={8} className='d-flex align-items-center'>
              <h1 className='h3'>{Strings('apps')}</h1>
            </Col>
          </Row>

          <Row>
            <Col>
              <RemixApps />
            </Col>
          </Row>

        </Container>
      </div>

      <Footer1 />
    </>
  );
}
